import * as React from "react";
import { classNames } from "react-select/lib/utils";
import { ReactNode } from "react";

interface IProps {
  title: string;
  endComponent?: ReactNode;
  className?: string;
}

const PageTitle = (props: IProps) => {
  const { title, endComponent, className } = props;

  return (
    <h1 className={classNames('title', className)}>
      {title}
      {endComponent}
    </h1>
  );
};
export default PageTitle;
